import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
export function CTASection() {
  const navigate = useNavigate();
  return <section className="py-24 bg-gradient-to-br from-violet-600 to-indigo-700 text-white text-center" data-id="element-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-102">
          Ready to automate your reconciliation?
        </h2>
        <p className="text-xl text-violet-100 mb-10 max-w-2xl mx-auto" data-id="element-103">
          Join 10+ small businesses saving time and eliminating errors with
          Berry Finance.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-104">
          {/* <Button
           size="lg"
           className=" text-black hover:bg-white hover:text-violet-900  border-none h-14 px-8 text-lg"
           onClick={() => navigate('/connect')}>
            Start your free trial
           </Button> */}
          <Button variant="outline" size="lg" className="border-violet-300 text-white hover:bg-white hover:text-violet-900  hover:border-violet-500 h-14 px-8 text-lg" data-id="element-105">

          <a href="https://tally.so/r/D4dgqb" target="_blank" rel="noopener noreferrer" data-id="element-106">
              
              Try Berry for Free
            </a> 
          </Button>
        </div>
        <p className="text-sm text-violet-200 font-medium" data-id="element-107">
          No credit card required • Free 500 transactions • Cancel anytime
        </p>
      </div>
    </section>;
}